import React from 'react';
import { SubmitButtonV3, SubmitButtonPropsV3 } from '../SubmitButton';

export type SaveButtonProps = Omit<SubmitButtonPropsV3, 'variantColor' | 'icon'>;

const SaveButtonV3: React.FC<SaveButtonProps> = ({ ...rest }) => {
  return <SubmitButtonV3 {...rest} />;
};

export default React.memo(SaveButtonV3);
